if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        if ('requestIdleCallback' in window) {
          requestIdleCallback(this.init.bind(this), { timeout: 1500 });
        } else {
          FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '0px 0px 400px 0px' });
        }
      }

      init() {
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((responseText) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.shopify-section');

            if (sectionInnerHTML === null) return;

            const recommendations = sectionInnerHTML.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            this.reloadSkeepersScript();

            if (recommendations.querySelector('.product-card')) {
              this.dispatchEvent(new CustomEvent('recommendations:loaded'));
            } else {
              if (recommendations.classList.contains('complementary-products')) {
                this.closest('.product__block').remove();
              } else {
                this.closest('.shopify-section').remove();
              }
              this.dispatchEvent(new CustomEvent('recommendations:empty'));
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }

      reloadSkeepersScript() {
        // Supprimer l'ancien script
        const oldScript = document.querySelector('script[src*="widgets.rr.skeepers.io/product"]');
        if (oldScript) oldScript.remove();

        // Créer un nouveau script
        const newScript = document.createElement('script');
        newScript.defer = true;
        newScript.charset = 'utf-8';
        newScript.src = 'https://widgets.rr.skeepers.io/product/c3e004b2-ef7c-3b34-c57d-314c44171c1a/8534f535-be21-440f-bb48-e032383390a6.js';

        // Ajouter à la fin du body
        document.body.appendChild(newScript);
      }
    }
  );
}
